import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/primitives';
import { EmptyState } from '../components/ui/states';
import { useT } from '../i18n';

export function NotFoundPage() {
  const t = useT();
  return (
    <>
      <PageHeader title={t.notFound.title} />
      <EmptyState
        title={t.notFound.emptyTitle}
        body={t.notFound.emptyBody}
        action={
          <Link className="btn btn--sm" to="/">
            {t.notFound.back}
          </Link>
        }
      />
    </>
  );
}
